import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {InsolesModelRepository} from "./impl/service/ngrx/insolesModel.repository";
import {InsolesModelDataService} from "./impl/service/ngrx/insolesModel.data.service";
import {InsolesModelDataServiceAdapter} from "./impl/service/ngrx/insolesModel.data.service.adapter";
import {InsolesModelSummaryDataServiceAdapter} from "./impl/service/ngrx/insolesModelSummary.data.service.adapter";

@NgModule({
    providers: [
        InsolesModelRepository,
        InsolesModelDataService,
        InsolesModelDataServiceAdapter,
        InsolesModelSummaryDataServiceAdapter
    ],
})
export class InsolesModelModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: InsolesModelRepository,
                 dataService: InsolesModelDataService,
    ) {

        entityDataService.registerServices({
            InsolesModel: dataService,
        });

        entityServices.registerEntityCollectionServices({
            InsolesModel: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
